import {
    createJustText,
    JustText,
} from '@vfde-brix/ws10/just-text';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { CLASSNAME_TEXT } from '@vfde-brix/ws10/styles';
import { startAppListening } from '../container/App/listener';
import {
    selectDevicesByCategory,
    selectError,
} from '../container/App/selectors';

/**
 * Mount JustText component for total devices
 */
export const mountJustText = (containerId: string): JustText | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const totalDevices = createJustText(container, {});

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectError(currentState) !== selectError(previousState),
        effect: (action, listenerApi) => {
            const hasError = selectError(listenerApi.getState());

            totalDevices?.toggleContainer(hasError);
        },
    });

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectDevicesByCategory(currentState) !== selectDevicesByCategory(previousState),
        effect: (action, listenerApi) => {
            const devices = selectDevicesByCategory(listenerApi.getState());

            totalDevices && updateTotalDevices(totalDevices, devices?.length || 0);
        },
    });

    return totalDevices;
};

/**
 * Update the component
 */
export const updateTotalDevices = (component: JustText, totalDevices: number): void => {
    let content;

    const { noResults, oneResult, default: defaultText } = window[ADDITIONAL_PAGE_OPTIONS].devices.totalDevices;

    switch (totalDevices) {
        case 0:
            content = noResults;
            break;
        case 1:
            content = oneResult;
            break;
        default:
            content = defaultText.replace(/\d+/, `<strong>${totalDevices}</strong>`);
            break;
    }

    component.update({
        content,
        className: CLASSNAME_TEXT,
    });
};
